// @ts-nocheck
import { addToCartButtonStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToCartButton";
import ShoppingCartFill from "@store/Library/Components/Toolkit/Icons/ShoppingCart/ShoppingCartFill";
import { buttonStyles } from "@store/Themes/common/mixins/button";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

Object.assign(addToCartButtonStyles, {
    button: {
        css: css`
            ${buttonStyles("solid")};
            height: 100%;
            justify-content: normal;
            margin-right: ${pxToRem(15)};

            [class*="ButtonIcon"] {
                margin-right: ${pxToRem(15)};
            }

            ${breakpoint("sm", "down")} {
                margin-top: ${pxToRem(20)};
            }
        `,
        icon: {
            src: ShoppingCartFill,
            position: "left",
        },
    },
});
